import React from "react";

const ACircleUserDisplay = ({
  firstname = "",
  lastname = "",
  email = "",
  hideUserPreview = false,
}) => {
  return (
    <div className="flex items-center">
      {!hideUserPreview && (
        <div className="flex shrink-0 items-center justify-center text-center rounded-full w-[32px] h-[32px] bg-[#4318FF]/[.18] text-[#4318FF] text-xs">
          {`${firstname.toUpperCase().substring(0, 1)}${lastname.toUpperCase().substring(0, 1)}`}
        </div>
      )}
      <div className={`flex flex-col text-sm text-[#171717] ${hideUserPreview ? "" : "ml-[12px]"}`}>
        <span>{`${firstname} ${lastname}`}</span>
        <span className="text-xs text-[#404040]/[0.6]">{`${email}`}</span>
      </div>
    </div>
  );
};

export default ACircleUserDisplay;
